export const splitUrl = (url: string) => {
  const [, lang, appId] = url.split("/");
  return {
    lang,
    appId,
  };
};
